require('&nummissmiu/default-missmiu.scss');

import basepage from '@num/entrypoints/basepage'
import Site from '@num/pages/PageControl'
import { setThemeConfig } from '@num/config'
import themeConfig from '../config'

setThemeConfig(themeConfig)
basepage(Site, { theme: "missmiu" })
